import { AUCTION_TYPES } from 'constants';
import { useMemo } from 'react';
import { useField } from 'react-final-form';
import { useGetRelistDataQuery } from 'services/api/admin-auction-vehicles';

export const useIsAlternativeAuctionSelected = (vehicleId: number) => {
  const { input: auctionInput } = useField('auctionId');
  const { data } = useGetRelistDataQuery(vehicleId);

  const selectedAuction = useMemo(() => {
    return data?.activeAuctions?.find(active => active.id === auctionInput.value?.value);
  }, [data, auctionInput.value]);

  const isAlternativeAuction = selectedAuction && selectedAuction.type !== AUCTION_TYPES.AUTOAXESS;
  return isAlternativeAuction;
};
